import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import Button from '../../../juristec-ui/core/Button';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';

import { CircleSuccess, CircleError } from '../../../juristec-ui/icons';

import {
  MessageColumn,
  MessageRow,
} from './styled/AllowL1ReportsBySupport.styled';

/**
 * A modal to handle the addition of new users to the instance
 */
const AllowL1ReportsBySupport = ({
  submit,
  hide,
  user,
  instanceHasAdminPermission,
  instanceHasSupportPermission,
  supportPermissionExpiration,
}) => {
  const theme = useTheme();

  const limitDate = new Date();
  limitDate.setDate(limitDate.getDate() + 10);

  const handleSubmit = () => {
    submit({ email: user?.email, id: user?.id }, limitDate);
  };

  return (
    <>
      <>
        {(instanceHasAdminPermission || instanceHasSupportPermission) ? (
          <>
            <MessageRow>
              <CircleSuccess fill={theme.success} width={20} />
              <span>
                O cliente já possui permissão para criação de relatórios Legal One.
              </span>
            </MessageRow>
            {instanceHasAdminPermission ? (
              <MessageColumn>
                <span>
                  O prazo de expiração dessa permissão não termina.
                </span>
              </MessageColumn>
            ) : (
              <MessageColumn>
                <span>
                  A permissão atual para a criação de relatórios Legal One expira em
                  {' '}
                  <strong>
                    {new Date(supportPermissionExpiration).toLocaleDateString('pt-PT', {
                      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
                    })}
                  </strong>
                </span>
                <span>
                  Deseja permitir que a expiração seja renovada até
                  {' '}
                  <strong>
                    {new Date(limitDate).toLocaleDateString('pt-PT', {
                      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
                    })}
                  </strong>
                  {' '}
                  ?
                </span>
              </MessageColumn>
            )}
          </>
        ) : (
          <>
            <MessageRow>
              <CircleError fill={theme.error} width={20} />
              <span>
                A instância ainda não possui permissão para criação de relatórios Legal One.
              </span>
            </MessageRow>
            <MessageColumn>
              <span>
                Deseja permitir que os usuários dessa instância criem relatórios Legal One?
              </span>
              <span>
                A permissão ficará ativa até
                {' '}
                <strong>
                  {new Date(limitDate).toLocaleDateString('pt-PT', {
                    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
                  })}
                </strong>
              </span>
            </MessageColumn>
          </>
        )}
      </>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={hide}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={() => handleSubmit()}
          size="large"
        >
          {instanceHasAdminPermission ? 'Ok' : 'Permitir'}
        </Button>
      </ActionsGroup>
    </>
  );
};

AllowL1ReportsBySupport.propTypes = {
  /**
   * A function that sends the new data back to the parent
   */
  submit: PropTypes.func.isRequired,
  /**
   * Function to close the modal
   */
  hide: PropTypes.func.isRequired,
  /**
   * A function to check if the instance has permission for L1 reports
   */
  user: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.string,
  }),
  /**
   * A function to check if the instance has permission for L1 reports
   */
  instanceHasAdminPermission: PropTypes.bool,
  /**
   * A function to check if the instance has support permission for L1 reports
   */
  instanceHasSupportPermission: PropTypes.bool,
  /**
   * The expiration date of the support permission for L1 reports or null if it doesn't exist
   */
  supportPermissionExpiration: PropTypes.string,
};

export default AllowL1ReportsBySupport;
